export enum ELoginStatus {
  Initial = 'Initial',
  Pending = 'Pending',
  Error = 'Error',
  LoggedIn = 'LoggedIn',
  Authorized = 'Authorized',
  Failed = 'Failed',
  LoggedOut = 'LoggedOut',
}

export interface IAuthState {
  status: ELoginStatus;
  token: string;
  accountConfirmationStatus: EAccountConfirmationStatus;
  resetPasswordStatus: EAccountConfirmationStatus;
  forgotPasswordStatus: EAccountConfirmationStatus;
  changePasswordStatus: EAccountConfirmationStatus;
  errorMessage: string;
}

export enum EAccountConfirmationStatus {
  Pending = 'Pending',
  Confirmed = 'Confirmed',
  Rejected = 'Rejected',
  Error = 'Error',
  LinkExpired = 'LinkExpired',
  Changed = 'Changed',
}
